<template>
  <div>
      <div class="mg10 pd15 mt20 kqf-card">
      <el-breadcrumb separator="/" style="font-size: 16px">
        <el-breadcrumb-item :to="{ path: '/orderManage/index' }">订单列表</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="kqf-card mg10 pd10 mt20" style="min-height: 152px">
        <div style="margin-bottom:10px">
        <p class="title mg10 ">基本信息</p>
        <div class="orderInfo pl10">
          <div>
            <p>ID：{{detail.order_id}} </p>
          </div>
          <div>
            <p>IMEI序列号：{{detail.imei}} </p>
          </div>
          <div>
            <p>名称：{{detail.nickname}} </p>
          </div>
          <div>
              <span style="line-height:30px">用户头像：</span> <el-avatar :size="30" :src="detail.face"></el-avatar>
          </div>
          <div>
            <p>手机号：{{detail.mobile}} </p>
          </div>
        </div>

      </div>
      <div style="margin-bottom:10px">
        <div class="orderInfo pl10">
          <div>
            <p>推广ID：{{detail.agent_uid}} </p>
          </div>
          <div>
            <p>查询类型：{{detail.menu_id}} </p>
          </div>  
          <div>
            <p>查询名称：{{detail.menu_name}} </p>
          </div>
          <div>
            <p>成本价：{{detail.cost_price}} </p>
          </div>
          <div>
            <p>销售价格：{{detail.price}} </p>
          </div>
        </div>

      </div>

      <div style="margin-bottom:10px">
         <div class="orderInfo pl10">
          <div>
            <p>支付金额：{{detail.pay_price}} </p>
          </div>
          <div>
            <p>分类ID：{{detail.category_id}} </p>
          </div>
          <div>
            <p>状态：{{detail.status == 1 ? '成功' : '失败'}} </p>
          </div>
          <div>
            <p>查询日期：{{detail.date}} </p>
          </div>
          <div>
            <p>创建时间：{{detail.create_time}} </p>
          </div>
        </div> 
      </div>
    </div>
    <div class="kqf-card mg10 pd10 mt20" style="min-height: 152px">
       <div style="margin-bottom:10px">
        <p class="title mg10 ">查询结果</p>
        <div class="result-box pl10" v-if="detail.status == 1">
          <div class="result-row" v-for="(item, index) in detail.result" :key="index">
            <template v-if="isObject(item)">
              <p class="result-key">{{ index }}：</p>
              <div class="result-sub" v-for="(subItem, subIndex) in item" :key="subIndex">
                <template v-if="isObject(subItem)">
                  <p class="result-key">{{ subIndex }}：</p>
                  <div class="result-sub2" v-for="(subItem2, subIndex2) in subItem" :key="subIndex2">
                    <p><span class="result-key">{{ subIndex2 }}：</span>{{ formatValue(subItem2) }}</p>
                  </div>
                </template>
                <template v-else>
                  <p><span class="result-key">{{ subIndex }}：</span>{{ formatValue(subItem) }}</p>
                </template>
              </div>
            </template>
            <template v-else>
              <p><span class="result-key">{{ index }}：</span>{{ formatValue(item) }}</p>
            </template>
          </div>
        </div>
       <div class="orderInfo pl10" v-if="detail.status == 0">
           <p>错误信息：{{detail.message}} </p>
       </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getDetails} from "../../request/api/orderManage/orderManage";

export default {
    data () {
        return {
            detail:{}
        }
    },
    mounted() {
        this.getDetail()
    },
    methods:{
        getDetail(){
            getDetails({order_id:this.$route.query.order_id}).then((res)=>{
                this.detail=res.details || {}
            })
        },
        isObject(val) {
            return val !== null && typeof val === 'object'
        },
        formatValue(val) {
            if (val === null || val === undefined) return ''
            if (typeof val === 'object') return JSON.stringify(val)
            return val
        }
    },
    
}
</script>

<style scoped lang="scss">
.orderInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  div {
    display: flex;
    width: 20%;
    align-items: left;
    margin-bottom:10px;
    .remarktext {
      width: 60px;
    }

    p.remark {
      background-color: #f1f2f6;
      width: 70%;
      font-size: 14px;
      padding: 8px;
      height: 99px;
    }
  }
}
.result-box {
  .result-row {
    width: 100%;
    margin-bottom: 12px;
    line-height: 1.6;
    word-break: break-all;
  }
  .result-key {
    font-weight: 600;
    color: #333;
  }
  .result-sub {
    margin-left: 16px;
    margin-top: 4px;
  }
  .result-sub2 {
    margin-left: 16px;
  }
}
.title {
  height: 28px;
  font-size: 16px;
  font-weight: 600;
  color: #222;
}
</style>
